import { useState } from 'react';
import { saveMonitoringTask, deleteMonitoringTask as delTask } from '../../api';

const EMPTY = { taskDescription: '', performedBy: '', weekly: '', monthly: '', quarterly: '', sixMonthly: '', annually: '' };

export default function MonitoringTab({ report, onSave, readOnly = false }) {
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [msg, setMsg] = useState('');

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const startNew = () => { setEditing('new'); setForm(EMPTY); };
  const startEdit = (item) => { setEditing(item.id); setForm({ ...item }); };
  const cancel = () => { setEditing(null); setForm(EMPTY); };

  const handleSave = async () => {
    try {
      await saveMonitoringTask(report.id, { ...form, id: editing === 'new' ? null : editing, sortOrder: (report.monitoringTasks || []).length });
      setEditing(null);
      setForm(EMPTY);
      setMsg('Saved');
      onSave();
      setTimeout(() => setMsg(''), 2000);
    } catch (err) { setMsg(err.message); }
  };

  const handleDelete = async (id) => { if (!window.confirm('Delete this monitoring task?')) return; await delTask(id); onSave(); };

  return (
    <div>
      {msg && <div className="alert alert-success">{msg}</div>}
      {!readOnly && <button className="btn btn-primary" onClick={startNew} style={{ marginBottom: '1rem' }}>Add Task</button>}

      {!readOnly && editing && (
        <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: '1rem', marginBottom: '1rem', background: '#fafafa' }}>
          <div className="form-group"><label>Task Description</label><input name="taskDescription" value={form.taskDescription} onChange={handleChange} /></div>
          <div className="form-row">
            <div className="form-group"><label>Performed By</label><input name="performedBy" value={form.performedBy} onChange={handleChange} /></div>
            <div className="form-group"><label>Weekly</label><input name="weekly" value={form.weekly} onChange={handleChange} /></div>
            <div className="form-group"><label>Monthly</label><input name="monthly" value={form.monthly} onChange={handleChange} /></div>
          </div>
          <div className="form-row">
            <div className="form-group"><label>Quarterly</label><input name="quarterly" value={form.quarterly} onChange={handleChange} /></div>
            <div className="form-group"><label>6 Monthly</label><input name="sixMonthly" value={form.sixMonthly} onChange={handleChange} /></div>
            <div className="form-group"><label>Annually</label><input name="annually" value={form.annually} onChange={handleChange} /></div>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button className="btn btn-primary" onClick={handleSave}>Save</button>
            <button className="btn btn-outline" style={{ color: '#333', borderColor: '#ccc' }} onClick={cancel}>Cancel</button>
          </div>
        </div>
      )}

      <div className="table-scroll">
        <table className="data-table">
          <thead><tr><th>Task</th><th>By</th><th>Wk</th><th>Mo</th><th>Qt</th><th>6Mo</th><th>Yr</th>{!readOnly && <th></th>}</tr></thead>
          <tbody>
            {(report.monitoringTasks || []).map((t) => (
              <tr key={t.id}>
                <td style={{ fontSize: '0.8rem' }}>{t.taskDescription}</td>
                <td>{t.performedBy}</td>
                <td>{t.weekly}</td>
                <td>{t.monthly}</td>
                <td>{t.quarterly}</td>
                <td>{t.sixMonthly}</td>
                <td>{t.annually}</td>
                {!readOnly && <td>
                  <button onClick={() => startEdit(t)} style={{ cursor: 'pointer', border: 'none', background: 'none', color: '#4361ee' }}>Edit</button>
                  <button onClick={() => handleDelete(t.id)} style={{ cursor: 'pointer', border: 'none', background: 'none', color: '#dc2626', marginLeft: 8 }}>Del</button>
                </td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {(report.monitoringTasks || []).length === 0 && <p style={{ color: '#888' }}>No monitoring tasks yet.</p>}
    </div>
  );
}
